import { postApi } from '../api/digitalVault';
import { chunkArray } from '../utils';
// TODO sort the duplicated code with the permanentDeleteFiles
const restoreTrashFiles = async (props, logger) => {
    const groupFiles = [];
    const batchSize = 120;
    const request = [];
    props.uri.forEach((uri) => {
        const repository = uri.split(/[:/]/)[4];
        const index = groupFiles.findIndex((item) => item?.repository === repository);
        if (index >= 0) {
            groupFiles[index]?.uriContainer.push(uri);
        }
        else {
            groupFiles.push({
                uriContainer: [uri],
                repository,
            });
        }
    });
    groupFiles.forEach(({ uriContainer }) => {
        const chunkedGroup = chunkArray(uriContainer, batchSize);
        chunkedGroup.forEach((array) => {
            const data = new URLSearchParams();
            array.forEach((uri) => data.append('uri', uri));
            request.push(data);
        });
    });
    return Promise.all(request.map(async (data) => {
        await postApi(data, 'uri/trash/restore', {}, logger);
    }));
};
export default restoreTrashFiles;
